/* global Plotly:true */

import React, { Component } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getPimaDataDec2021,
  getPimaDataNov2021,
  getPimaDataOct2021,
  getPimaDataSep2021,
  getPimaDataAgo2021,
  getPimaDataJul2021,
  getPimaDataJun2021,
  getPimaDataMay2021,
  getPimaDataApr2021,
  getPimaDataMar2021,
  getPimaDataFeb2021,
  getPimaDataJan2021,
  getPimaDataDec2020,
  getPimaDataNov2020,
  getPimaDataOct2020,
  getPimaDataSep2020,
  getPimaDataAgo2020,
  getPimaDataJul2020,
  getPimaDataJun2020,
  getPimaDataMay2020,
  getPimaDataApr2020,
  getPimaDataMar2020,
} from "../../actions/pimadataActions";

const Plot = createPlotlyComponent(Plotly);

class MonthlyInfections extends Component {
  // MANUAL AQUÍ MENSUAL
  componentDidMount() {
    this.props.getPimaDataDec2021();
    this.props.getPimaDataNov2021();
    this.props.getPimaDataOct2021();
    this.props.getPimaDataSep2021();
    this.props.getPimaDataAgo2021();
    this.props.getPimaDataJul2021();
    this.props.getPimaDataJun2021();
    this.props.getPimaDataMay2021();
    this.props.getPimaDataApr2021();
    this.props.getPimaDataMar2021();
    this.props.getPimaDataFeb2021();
    this.props.getPimaDataJan2021();
    this.props.getPimaDataDec2020();
    this.props.getPimaDataNov2020();
    this.props.getPimaDataOct2020();
    this.props.getPimaDataSep2020();
    this.props.getPimaDataAgo2020();
    this.props.getPimaDataJul2020();
    this.props.getPimaDataJun2020();
    this.props.getPimaDataMay2020();
    this.props.getPimaDataApr2020();
    this.props.getPimaDataMar2020();
  }

  render() {
    const {
      pdago2020,
      pdapr2020,
      pddec2020,
      pdjul2020,
      pdjun2020,
      pdmar2020,
      pdmay2020,
      pdnov2020,
      pdoct2020,
      pdsep2020,
      pdjan2021,
      pdago2021,
      pdapr2021,
      pddec2021,
      pdjul2021,
      pdjun2021,
      pdmar2021,
      pdmay2021,
      pdnov2021,
      pdoct2021,
      pdsep2021,
      pdfeb2021,
    } = this.props;

    const pds2021 = [
      pdmar2020,
      pdapr2020,
      pdmay2020,
      pdjun2020,
      pdjul2020,
      pdago2020,
      pdsep2020,
      pdoct2020,
      pdnov2020,
      pddec2020,
      pdjan2021,
      pdfeb2021,
      pdmar2021,
      pdapr2021,
      pdmay2021,
      pdjun2021,
      pdjul2021,
      pdago2021,
      pdsep2021,
      pdoct2021,
      pdnov2021,
      pddec2021,
    ];

    var monthlySums = [];

    var countMonths = 0;
    var sum = 0;
    for (var x = 0; x < pds2021.length; x++) {
      if (pds2021[x].length > 0) {
        sum = 0;
        for (var z = 0; z < pds2021[x].length; z++) {
          sum =
            sum +
            parseFloat(pds2021[x][z].new_cases_today_pima.replace(/,/g, ""));
        }
        monthlySums.push(sum);
        countMonths++;
      }
    }

    const allMonths = [
      "Mar 20",
      "Apr 20",
      "May 20",
      "Jun 20",
      "Jul 20",
      "Ago 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
      "Apr 21",
      "May 21",
      "Jun 21",
      "Jul 21",
      "Ago 21",
      "Sep 21",
      "Oct 21",
      "Nov 21",
      "Dec 21",
    ];
    const months = [];
    for (var y = 0; y < countMonths; y++) {
      months.push(allMonths[y]);
    }
    var annotations = [];
    for (var a = 0; a < monthlySums.length; a++) {
      if (a !== monthlySums.length - 1) {
        annotations.push({
          x: a,
          y: monthlySums[a],
          xref: "x",
          yref: "y",
          text: monthlySums[a]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
          showarrow: true,
          font: {
            size: 18,
            color: "#ffffff",
          },
          align: "center",
          arrowhead: 2,
          arrowsize: 1,
          arrowwidth: 2,
          arrowcolor: "black",
          ax: 0,
          ay: -45,
          bordercolor: "black",
          borderwidth: 2,
          borderpad: 1,
          bgcolor: "black",
          opacity: 1,
        });
      } else
        annotations.push({
          x: a,
          y: monthlySums[a],
          xref: "x",
          yref: "y",
          text: `${monthlySums[a]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}*`,
          showarrow: true,
          font: {
            size: 18,
            color: "#ffffff",
          },
          align: "center",
          arrowhead: 2,
          arrowsize: 1,
          arrowwidth: 2,
          arrowcolor: "black",
          ax: 0,
          ay: -45,
          bordercolor: "black",
          borderwidth: 2,
          borderpad: 1,
          bgcolor: "black",
          opacity: 1,
        });
    }

    var today = new Date();
    if (today.getHours() > 9) {
      var dd = today.getDate();

      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      var date = mm + "-" + dd + "-" + yyyy;
    } else if (today.getHours() === 9) {
      if (today.getMinutes() < 29) {
        var yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        dd = yesterday.getDate();
        mm = yesterday.getMonth() + 1;
        yyyy = yesterday.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      } else {
        dd = today.getDate();

        mm = today.getMonth() + 1;
        yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      }
    } else {
      yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      dd = yesterday.getDate();
      mm = yesterday.getMonth() + 1;
      yyyy = yesterday.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      date = mm + "-" + dd + "-" + yyyy;
    }

    return (
      <div>
        <h4 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
          Pima County COVID-19 Total Infections Per Month
          <br />
          {/* MANUAL AQUÍ DIARIO */}
          <span style={{ fontWeight: "normal", fontSize: "16px" }}>
            * Last Update {date} at 9:30 AM
          </span>
        </h4>
        <Plot
          useResizeHandler
          style={{ width: "100%", height: "100vh" }}
          data={[
            {
              line: { color: "rgb(220, 71, 46)", width: 4 },
              meta: { columnNames: { x: "A", y: "C" } },
              mode: "lines+markers+text",
              marker: {
                size: 10,
                maxdisplayed: months.length,
                color: "black",
              },
              type: "scatter",
              xsrc: "AlejandroGalavizSalazar:0:4f5e9d",
              x: months,
              name: "<b>Monthly Infections</b>",
              ysrc: "AlejandroGalavizSalazar:0:f0c424",
              y: monthlySums,
              showlegend: true,
              orientation: "v",
              textinfo: "value",
              textposition: "top-center",
              textfont: { size: 18 },
            },
          ]}
          layout={{
            autosize: true,
            margin: {
              l: 0,
              r: 0,
              b: 20,
              t: 140,
              pad: 4,
            },
            title: {
              // MANUAL AQUÍ DIARIO
              text: `<b style='font-size:32px;color:black'>Pima County COVID-19 Total Infections Per Month</b><br><span style= 'font-weight: normal, font-size: 16px'>* Last Update ${date} at 9:30 AM</span>`,
            },
            xaxis: {
              type: "category",
              range: [-0.5, 186.5],
              nticks: months.length,
              autorange: true,
              title: {
                font: { size: 18, color: "black" },
                text: "<br><b>Month</b>",
              },
            },
            yaxis: {
              type: "linear",
              range: [-270.3412698412698, 5147.912698412699],
              autorange: true,
              title: {
                font: { size: 18, color: "black" },
                text: "<b>Monthly Infections</b><br>",
              },
            },
            legend: {
              x: -0.03,
              y: 1.025,
              font: { size: 15, color: "black" },
              bgcolor: "transparent",
            },
            annotations,
            template: {
              data: {
                bar: [
                  {
                    type: "bar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                table: [
                  {
                    type: "table",
                    cells: {
                      fill: { color: "#e8ebef" },
                      line: { color: "white" },
                    },
                    header: {
                      fill: { color: "#C8D4E3" },
                      line: { color: "white" },
                    },
                  },
                ],
                carpet: [
                  {
                    type: "carpet",
                    aaxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                    baxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                  },
                ],
                mesh3d: [
                  {
                    type: "mesh3d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                contour: [
                  {
                    type: "contour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                heatmap: [
                  {
                    type: "heatmap",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatter: [
                  {
                    type: "scatter",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                surface: [
                  {
                    type: "surface",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                heatmapgl: [
                  {
                    type: "heatmapgl",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                histogram: [
                  {
                    type: "histogram",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                parcoords: [
                  {
                    line: { colorbar: { ticks: "", outlinewidth: 0 } },
                    type: "parcoords",
                  },
                ],
                scatter3d: [
                  {
                    type: "scatter3d",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattergl: [
                  {
                    type: "scattergl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                choropleth: [
                  {
                    type: "choropleth",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattergeo: [
                  {
                    type: "scattergeo",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2d: [
                  {
                    type: "histogram2d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatterpolar: [
                  {
                    type: "scatterpolar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                contourcarpet: [
                  {
                    type: "contourcarpet",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattercarpet: [
                  {
                    type: "scattercarpet",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattermapbox: [
                  {
                    type: "scattermapbox",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterpolargl: [
                  {
                    type: "scatterpolargl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterternary: [
                  {
                    type: "scatterternary",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2dcontour: [
                  {
                    type: "histogram2dcontour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
              },
              layout: {
                geo: {
                  bgcolor: "white",
                  showland: true,
                  lakecolor: "white",
                  landcolor: "white",
                  showlakes: true,
                  subunitcolor: "#C8D4E3",
                },
                font: { color: "#2a3f5f" },
                polar: {
                  bgcolor: "white",
                  radialaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                  angularaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                },
                scene: {
                  xaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  yaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  zaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                },
                title: { x: 0.05 },
                xaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                yaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                ternary: {
                  aaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  baxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  caxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  bgcolor: "white",
                },
                colorway: [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#19d3f3",
                  "#e763fa",
                  "#fecb52",
                  "#ffa15a",
                  "#ff6692",
                  "#b6e880",
                ],
                hovermode: "closest",
                colorscale: {
                  diverging: [
                    [0, "#8e0152"],
                    [0.1, "#c51b7d"],
                    [0.2, "#de77ae"],
                    [0.3, "#f1b6da"],
                    [0.4, "#fde0ef"],
                    [0.5, "#f7f7f7"],
                    [0.6, "#e6f5d0"],
                    [0.7, "#b8e186"],
                    [0.8, "#7fbc41"],
                    [0.9, "#4d9221"],
                    [1, "#276419"],
                  ],
                  sequential: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                  sequentialminus: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                },
                plot_bgcolor: "white",
                paper_bgcolor: "white",
                shapedefaults: {
                  line: { width: 0 },
                  opacity: 0.4,
                  fillcolor: "#506784",
                },
                annotationdefaults: {
                  arrowhead: 0,
                  arrowcolor: "#506784",
                  arrowwidth: 1,
                },
              },
              themeRef: "PLOTLY_WHITE",
            },
            showlegend: true,
          }}
        />
      </div>
    );
  }
}
MonthlyInfections.propTypes = {
  getPimaDataJan2021: PropTypes.func.isRequired,
  getPimaDataDec2020: PropTypes.func.isRequired,
  getPimaDataNov2020: PropTypes.func.isRequired,
  getPimaDataOct2020: PropTypes.func.isRequired,
  getPimaDataSep2020: PropTypes.func.isRequired,
  getPimaDataAgo2020: PropTypes.func.isRequired,
  getPimaDataJul2020: PropTypes.func.isRequired,
  getPimaDataJun2020: PropTypes.func.isRequired,
  getPimaDataMay2020: PropTypes.func.isRequired,
  getPimaDataApr2020: PropTypes.func.isRequired,
  getPimaDataMar2020: PropTypes.func.isRequired,
  getPimaDataFeb2021: PropTypes.func.isRequired,
  getPimaDataDec2021: PropTypes.func.isRequired,
  getPimaDataNov2021: PropTypes.func.isRequired,
  getPimaDataOct2021: PropTypes.func.isRequired,
  getPimaDataSep2021: PropTypes.func.isRequired,
  getPimaDataAgo2021: PropTypes.func.isRequired,
  getPimaDataJul2021: PropTypes.func.isRequired,
  getPimaDataJun2021: PropTypes.func.isRequired,
  getPimaDataMay2021: PropTypes.func.isRequired,
  getPimaDataApr2021: PropTypes.func.isRequired,
  getPimaDataMar2021: PropTypes.func.isRequired,
  pdjan2021: PropTypes.array.isRequired,
  pddec2020: PropTypes.array.isRequired,
  pdnov2020: PropTypes.array.isRequired,
  pdoct2020: PropTypes.array.isRequired,
  pdsep2020: PropTypes.array.isRequired,
  pdago2020: PropTypes.array.isRequired,
  pdjul2020: PropTypes.array.isRequired,
  pdjun2020: PropTypes.array.isRequired,
  pdmay2020: PropTypes.array.isRequired,
  pdapr2020: PropTypes.array.isRequired,
  pdmar2020: PropTypes.array.isRequired,
  pdfeb2021: PropTypes.array.isRequired,
  pddec2021: PropTypes.array.isRequired,
  pdnov2021: PropTypes.array.isRequired,
  pdoct2021: PropTypes.array.isRequired,
  pdsep2021: PropTypes.array.isRequired,
  pdago2021: PropTypes.array.isRequired,
  pdjul2021: PropTypes.array.isRequired,
  pdjun2021: PropTypes.array.isRequired,
  pdmay2021: PropTypes.array.isRequired,
  pdapr2021: PropTypes.array.isRequired,
  pdmar2021: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  pdjan2021: state.pimadata.pdjan2021,
  pddec2020: state.pimadata.pddec2020,
  pdnov2020: state.pimadata.pdnov2020,
  pdoct2020: state.pimadata.pdoct2020,
  pdsep2020: state.pimadata.pdsep2020,
  pdago2020: state.pimadata.pdago2020,
  pdjul2020: state.pimadata.pdjul2020,
  pdjun2020: state.pimadata.pdjun2020,
  pdmay2020: state.pimadata.pdmay2020,
  pdapr2020: state.pimadata.pdapr2020,
  pdmar2020: state.pimadata.pdmar2020,
  pdfeb2021: state.pimadata.pdfeb2021,
  pddec2021: state.pimadata.pddec2021,
  pdnov2021: state.pimadata.pdnov2021,
  pdoct2021: state.pimadata.pdoct2021,
  pdsep2021: state.pimadata.pdsep2021,
  pdago2021: state.pimadata.pdago2021,
  pdjul2021: state.pimadata.pdjul2021,
  pdjun2021: state.pimadata.pdjun2021,
  pdmay2021: state.pimadata.pdmay2021,
  pdapr2021: state.pimadata.pdapr2021,
  pdmar2021: state.pimadata.pdmar2021,
});

export default connect(mapStateToProps, {
  getPimaDataAgo2020,
  getPimaDataApr2020,
  getPimaDataDec2020,
  getPimaDataJan2021,
  getPimaDataJul2020,
  getPimaDataJun2020,
  getPimaDataMar2020,
  getPimaDataMay2020,
  getPimaDataNov2020,
  getPimaDataOct2020,
  getPimaDataSep2020,
  getPimaDataAgo2021,
  getPimaDataApr2021,
  getPimaDataDec2021,
  getPimaDataFeb2021,
  getPimaDataJul2021,
  getPimaDataJun2021,
  getPimaDataMar2021,
  getPimaDataMay2021,
  getPimaDataNov2021,
  getPimaDataOct2021,
  getPimaDataSep2021,
})(MonthlyInfections);
